<template>
  <div class="step-one">
    <!-- Event Type -->
    <div v-if="!eventId && !['salesDistribution', 'pendingEventStore', 'store', 'storeMaintain'].includes(pageType)" class="form-item">
      <div class="label required">{{ $t('form.eventType') }}</div>
      <div class="type-selector">
        <div class="type-card" :class="{ active: eventType === 1 }" @click="handleType(1)">
          {{ $t('form.popUp') }}
        </div>
        <div v-if="!eventId && checkPer(['admin', 'app:eventSd:add'])" class="type-card" :class="{ active: eventType === 2 }" @click="handleType(2)">
          <!-- {{ globalData.brandName }} Day -->
          {{ $t('form.brandDay') }}
        </div>
      </div>
    </div>

    <!-- Event Time -->
    <div class="form-item">
      <div class="label required">{{ $t('form.eventTime') }}</div>
      <div class="date-range-picker" @click="handleDate('start')" :class="{'is-disable': isDisable || ![0, '0'].includes(this.status) && this.eventId}">
        <div class="date-input" :class="{ placeholder: !startTime }">
          {{ startTime || $t('form.startTime') }}
        </div>
        <span class="separator">~</span>
        <div class="date-input" :class="{ placeholder: !endTime }" @click.stop="handleDate('end')">
          {{ endTime || $t('form.endTime') }}
        </div>
      </div>
      <van-popup v-model="showStartPicker" position="bottom">
        <van-datetime-picker
          v-model="currentStartDate"
          type="datetime"
          :title="$t('form.selectStartTime')"
          :min-date="minDate"
          @confirm="onConfirmStartTime"
          @cancel="showStartPicker = false"
        />
      </van-popup>

      <van-popup v-model="showEndPicker" position="bottom">
        <van-datetime-picker
          v-model="currentEndDate"
          type="datetime"
          :title="$t('form.selectEndTime')"
          :min-date="minDate"
          @confirm="onConfirmEndTime"
          @cancel="showEndPicker = false"
        />
      </van-popup>
    </div>

    <!-- Store -->
    <div class="form-item">
      <div class="label required">{{ eventType === 2 ? $t('shared.distributor') : $t('shared.store') }}</div>
      <van-field readonly clickable :value="storeName" :disabled="eventId || isDisable ? true : false || singleDisable" :placeholder="$t('button.select')" @click="handleStore" class="custom-field" />
      <XuStoreSelect v-model="showStorePicker" @confirm="onConfirmStore" :apiType="eventType" />
    </div>

    <!-- Policy -->
    <div class="form-item">
      <div class="label-row">
        <span class="label required">{{ $t('form.policy') }}</span>
        <span class="action-btn" @click="goToSelectPolicy" v-if="!eventId && selectedPolicy">{{ $t('button.exchange') }}</span>
      </div>

      <div v-if="selectedPolicy" class="selected-policy-wrapper">
        <PolicyCard :policy="selectedPolicy" :selected="true" :collapsible="false" />
      </div>
      <div v-else class="selected-policy-wrapper unselecte-policy-wrapper" @click="goToSelectPolicy">
        <van-icon name="plus" color="#e9effb" size="50" />
      </div>
    </div>
  </div>
</template>

<script>
import PolicyCard from '../PolicyCard'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  props: {
    eventId: {
      type: String,
      default: ''
    },
    isDisable: {
      type: Boolean,
      default: false
    },
    singleDisable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PolicyCard,
    XuStoreSelect: () => import('@/components/XuStoreSelect')
  },
  data () {
    return {
      eventType: 1,
      startTime: '',
      endTime: '',
      showStartPicker: false,
      showEndPicker: false,
      currentStartDate: new Date(),
      currentEndDate: new Date(),
      minDate: new Date(2020, 0, 1),
      storeName: '',
      storeId: '',
      showStorePicker: false,
      storeList: [],
      loading: false,
      finished: false,
      page: 1,
      pageSize: 20,
      status: '',
      searchValue: '',
      pageType: ''
    }
  },
  computed: {
    ...mapState(['selectedPolicy', 'globalData'])
  },
  activated () {
    const { pageType, eventType } = this.$route.query
    this.pageType = pageType
    if (['salesDistribution'].includes(pageType)) {
      this.eventType = 2
    } else {
      this.eventType = Number(sessionStorage.getItem('eventType')) || Number(eventType) || 1
    }
    this.showStorePicker = false
  },
  methods: {
    handleDate (type) {
      if (this.isDisable) {
        return
      }
      if (![0, '0'].includes(this.status) && this.eventId) {
        return
      }
      if (type === 'start') {
        this.showStartPicker = true
      } else {
        this.showEndPicker = true
      }
    },
    handleStore () {
      if (this.eventId || this.isDisable || this.singleDisable) {
        return
      }
      this.page = 1
      // this.searchValue = ''
      // this.storeList = []
      // this.finished = false
      this.showStorePicker = true
      // this.onLoadStore()
    },
    formatDateTime (date) {
      const pad = (n) => n < 10 ? `0${n}` : n
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
    },
    onConfirmStartTime (value) {
      this.startTime = this.formatDateTime(value)
      this.showStartPicker = false
    },
    onConfirmEndTime (value) {
      this.endTime = this.formatDateTime(value)
      this.showEndPicker = false
    },
    onConfirmStore (item) {
      this.storeName = this.eventType === 2 ? item.sdName : item.customerName
      this.storeId = item.id
      this.showStorePicker = false
      this.$emit('handleInfo', { customerId: item.id })
    },
    goToSelectPolicy () {
      window.sessionStorage.setItem('eventType', this.eventType)
      this.$router.push(`/selectPolicy?eventType=${this.eventType}`)
    },
    checkVerify () {
      // 验证逻辑
      if (
        !this.eventType ||
        !this.startTime ||
        !this.endTime ||
        !this.storeId ||
        !this.selectedPolicy
      ) {
        this.$toast(this.$t('tips.messageSix'))
        return false
      }
      const { startTime, endTime, days } = this.selectedPolicy
      if (!(moment(this.startTime).format('x') >= moment(startTime).format('x') && moment(this.endTime).format('x') <= moment(endTime).format('x'))) {
        this.$toast(this.$t('tips.messageSeven'))
        return false
      }
      // 解析时间字符串
      const newStartTime = moment(this.startTime, 'YYYY-MM-DD')
      const newEndTime = moment(this.endTime, 'YYYY-MM-DD')

      // 计算日期差（按天）
      const diffDays = newEndTime.diff(newStartTime, 'days')

      // 检查结束时间的时分是否为 '00:00'
      const endHourMinute = moment(this.newEndTime, 'YYYY-MM-DD HH:mm').format('HH:mm')
      const shouldAddOneDay = endHourMinute !== '00:00'

      // 最终结果
      const finalDays = diffDays + (shouldAddOneDay ? 1 : 0)
      if (finalDays > days) {
        this.$toast(this.$t('tips.messageSeven'))
        return false
      }
      return true
    },
    editEcho (data) {
      this.startTime = data.startTime
      this.endTime = data.endTime
      this.storeName = data.customerName
      this.storeId = data.customerId
      this.status = data.status
      this.eventType = data.eventType
    },
    handleType (type) {
      if (this.eventId || this.isDisable || this.singleDisable) {
        return
      }
      this.eventType = type
      this.storeName = ''
      this.storeId = ''
      this.$emit('changeType', type)
    }
  }
}
</script>

<style lang="less" scoped>
.step-one {
  padding: 10px 16px;

  .form-item {
    margin-bottom: 20px;

    .label {
      font-size: 12px;
      color: #333;
      margin-bottom: 8px;

      &.required::after {
        content: '*';
        color: red;
        margin-left: 2px;
      }
    }

    .label-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;

      .action-btn {
        color: #1989fa;
        font-size: 14px;
      }
    }

    .type-selector {
      display: flex;
      justify-content: space-between;

      .type-card {
        width: 48%;
        height: 80px;
        border: 1px solid #ddd;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        color: #666;
        transition: all 0.3s;

        &.active {
          background-color: #1989fa;
          color: #fff;
          border-color: #1989fa;
        }
      }
    }
    .store-info {
      display: flex;
      align-items: center;
      .store-status {
        max-width: 100px;
        padding: 0px 5px;
        background-color: rgba(238, 84, 27, 0.19);
        border: 1px solid #ee541b;
        color: #ee541b;
        font-size: 10px;
        margin-right: 6px;
        line-height: 21px;
      }
      .unverified-store {
        color: #0db00b;
        border: 1px solid #0db00b;
        background-color: rgba(13, 176, 11, 0.19);
      }
      .regular-store {
        color: #7f7f7f;
        background-color: rgba(127, 127, 127, 0.19);
        border-color: #7f7f7f;
      }
      .store-name {
        flex: 1;
        font-size: 14px;
        font-weight: bold;
      }
    }
    .address-info {
      display: flex;
      align-items: center;
      font-size: 10px;
      color: #969799;
      .address-img {
        width: 13px;
        height: 13px;
        margin-right: 6px;
      }
    }
  }

  .picker-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    padding: 0 16px;
    background-color: #fff;
    border-bottom: 1px solid #ebedf0;

    .cancel-btn {
      color: #969799;
      font-size: 14px;
      cursor: pointer;
    }

    .title {
      font-weight: 500;
      font-size: 16px;
    }

    .confirm-btn {
      width: 28px;
    }
  }

  .store-list-container {
    height: calc(100% - 44px);
    overflow-y: auto;
  }

  .date-range-picker {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #b9cbed;
    border-radius: 4px;
    padding: 10px;
    background-color: #fff;

    .date-input {
      flex: 1;
      font-size: 14px;
      color: #323233;
      text-align: center;

      &.placeholder {
        color: #c8c9cc;
      }
    }

    .separator {
      margin: 0 10px;
      color: #969799;
    }
  }

  .is-disable {
    .date-input {
      color: #c8c9cc;
    }
  }

  .form-item {
    .custom-field {
      border: 1px solid #b9cbed;
      border-radius: 4px;
      padding: 5px 10px;
      color: #000;
    }
  }
  .selected-policy-wrapper {
    width: 100%;
    min-height: 160px;
    border: 1px solid #b9cbed;
    border-radius: 10px;
  }
  .unselecte-policy-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
